module.exports = __webpack_public_path__ + "static/media/bees-4845211.64c8e36d.jpg";